import React from 'react';
import { Link } from 'react-router-dom';

// Presentational Component
const Registration = () => {
	return (
		<div>
			<h2 id="tasks_registration">Preregister a User</h2>

			<h3><Link to="/api/Registration#post-manage-preregister">/v1/manage/preregister</Link></h3>
			<p>This endpoint will create a new user in the preregistered state. The user will then need to sign on and complete registration.</p>

			<p><em>Note: If <strong>notificationDefault</strong> is not explicitly set, it will default to <strong>Immediately</strong>, which means the user will begin receiving email notifications immediately. If set to AfterFirstLogin, then the user will only begin to receive email notifications after they have logged on.</em></p>

			<p><em>If <strong>sendInvitationEmail</strong> is not explicitly set, it will default to <strong>true</strong>, which means the user will receive an email inviting them to join the community. If set to <strong>false</strong>, then the user will not receive an email inviting them to join the community.</em></p>

			<p>Please see our <Link to="/api/Registration#post-manage-preregister">reference page</Link> for more details on the request parameters and response.</p>

			<h4>Example Request Object: </h4>
			<pre className="language-javascript"><code className="language-javascript">{`{
	"email": "JaneDoe1@yourcompany.com",
	"firstName": "Jane",
	"lastName": "Doe",
	"divisionIds": [1,4,10],
	"targetIds": [11, 22],
	"tags": [
		{
			"name": "Hourly Employee"
		},
		{
			"name": "Main Floor"
		}
	],
	"notificationsDefault": "AfterFirstLogin",
	"sendInvitationEmail": false
}`}
			</code></pre>
		</div>
	);
};

export default Registration;



// WEBPACK FOOTER //
// ./src/components/getting-started/simpleTasks/PreregisterUser.js